import { useRef } from 'react';
import { useSearchParams } from 'react-router-dom';
import { Box, Svg, SvgAction, TextField } from '@hopskipdrive/react-components';

import { SearchContainer } from './styles';

export const QuerySearch = () => {
  const ref = useRef<HTMLInputElement>(null);
  const [searchParams, setSearchParams] = useSearchParams();

  const handleSearch = async (e) => {
    const searchValue = e.target.value;

    if (e && (e.key === 'Enter' || e.code === 'Enter' || e.key === 13)) {
      if (searchValue) {
        setSearchParams((prevParams) => {
          return new URLSearchParams({
            ...Object.fromEntries(prevParams.entries()),
            q: searchValue,
          });
        });
      } else {
        searchParams.delete('q');
        setSearchParams(searchParams);
      }
      e.target.blur();
    }
  };

  return (
    <SearchContainer>
      <TextField
        inputRef={ref}
        data-testid="query-search"
        size="small"
        variant="outlined"
        InputProps={{
          startAdornment: (
            <Box mr={2}>
              <Svg icon="search" />
            </Box>
          ),
          endAdornment: (
            <div
              role="button"
              tabIndex={0}
              onKeyDown={(event) => {
                if (event.key === 'Enter' || event.key == ' ') {
                  ref?.current ? (ref.current.value = '') : null;
                  searchParams.delete('q');
                  setSearchParams(searchParams);
                }
              }}
              onClick={() => {
                ref?.current ? (ref.current.value = '') : null;
                searchParams.delete('q');
                setSearchParams(searchParams);
              }}
            >
              <SvgAction icon="close" display={searchParams.get('q') ? '' : 'none'} />
            </div>
          ),
        }}
        defaultValue={searchParams.get('q')}
        placeholder="Search Riders, tags, or locations"
        onKeyDown={handleSearch}
      />
    </SearchContainer>
  );
};
